import * as React from "react";

import { useCallbackRef } from "./use-callback-ref";

export function useDebouncedCallback<Args extends unknown[], Result>(
  callback: (...args: Args) => Result,
  delay: number
) {
  const handleCallback = useCallbackRef(callback);
  const debounceTimerRef = React.useRef(0);
  React.useEffect(() => () => window.clearTimeout(debounceTimerRef.current), []);

  const setValue = React.useCallback(
    (...args: Args) => {
      window.clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = window.setTimeout(() => handleCallback(...args), delay);
    },
    [handleCallback, delay]
  );

  return setValue;
}
